"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import classNames from "classnames";
import { escapeRegExp } from "../../util/strings";
function cloneElement(e) {
  const clone = e.target.cloneNode();
  clone.removeAttribute("data-reactid");
  return clone;
}
function shouldHighlight(escapedTextToHighlight, line) {
  if (!escapedTextToHighlight) {
    return false;
  }
  return line.chars.match(escapedTextToHighlight);
}
function textLine(props, escapedTextToHighlight, line, index) {
  const className = classNames({
    "o-t": true,
    "o-h": shouldHighlight(escapedTextToHighlight, line)
  });
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: styleForLine(props, line),
      "data-chars": line.chars,
      "data-top": line.top,
      "data-left": line.left,
      "data-width": line.width,
      "data-height": line.height,
      className,
      children: "\xA0"
    },
    "text_line_" + index
  );
}
function styleForLine(props, line) {
  return {
    top: line.top * (props.imageHeight || 0),
    left: line.left * (props.imageWidth || 0),
    width: line.width * (props.imageWidth || 0) + 2,
    height: line.height * (props.imageHeight || 0) + 2
  };
}
class PageTextHighlighter extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "containerRef", React.createRef());
    __publicField(this, "enableDragAndDrop", () => {
      var _a;
      $((_a = this.containerRef.current) != null ? _a : []).find(".o-t").draggable({
        cursor: "move",
        revert: "invalid",
        scope: "dnd-text",
        zIndex: 100,
        appendTo: "body",
        helper: cloneElement
      });
    });
    __publicField(this, "disableDragAndDrop", () => {
      var _a;
      $((_a = this.containerRef.current) != null ? _a : []).find(".ui-draggable").draggable("destroy");
    });
  }
  componentDidUpdate(prevProps) {
    if (this.props.lines !== prevProps.lines) {
      this.enableDragAndDrop();
    }
  }
  componentDidMount() {
    this.enableDragAndDrop();
  }
  componentWillUnmount() {
    this.disableDragAndDrop();
  }
  render() {
    const classes = classNames({
      "ocred-document__wrapper": true,
      "ocred-document__wrapper--enabled": true
    });
    const escapedTextToHighlight = escapeRegExp(this.props.textToHighlight);
    return /* @__PURE__ */ jsx(
      "div",
      {
        "data-component": "PageTextHighlighter",
        className: classes,
        ref: this.containerRef,
        children: _.map(
          this.props.lines,
          (line, index) => textLine(this.props, escapedTextToHighlight, line, index)
        )
      }
    );
  }
}
export default PageTextHighlighter;
